import { render, staticRenderFns } from "./Flux.vue?vue&type=template&id=7fd62a39&scoped=true&"
import script from "./Flux.vue?vue&type=script&lang=js&"
export * from "./Flux.vue?vue&type=script&lang=js&"
import style0 from "./Flux.vue?vue&type=style&index=0&id=7fd62a39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd62a39",
  null
  
)

export default component.exports